import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// icons
import { Icon } from '@iconify/react';
// @mui
import { Box, Tooltip } from '@mui/material';

// ----------------------------------------------------------------------

const Iconify = forwardRef(({ icon, width = 20, sx, tooltip, ...other }, ref) => (
    <Tooltip title={tooltip || ''}>
        <Box ref={ref} component={Icon} icon={icon} sx={{ width, height: width, ...sx }} {...other} />
    </Tooltip>
));

Iconify.propTypes = {
    sx: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    tooltip: PropTypes.string, // Thêm prop cho tooltip
};

export default Iconify;
